import React from "react";
import NavBar from "../components/NavBar";
import "../components/NavBar.css";
import "./Home.css";
import Footer from "../components/Footer";
import "../components/Footer.css"
import ProfilePic from "../components/ProfilePic.jpeg"; // Import your profile image

function Home() {
  return (
    <div>
      <NavBar />
      <div className="home-container">
        <div className="intro-section">
          <div className="intro-paragraph">
            <div className="intro-content">
              <h1>
                Hello, my name is <span className="highlight">Cade Wied</span>
              </h1>
              <h2>
                I'm a <span className="highlight">Full Stack Developer</span>
              </h2>
              <p>
                In the 82nd Airborne Division. I specialize in building dynamic and
                robust web applications using a variety of languages and frameworks.
                My mission is to deliver high-quality, scalable solutions that meet
                the needs of modern users. Feel free to message or follow me on GitHub or Linkedin by clicking the icons below.
              </p>
            </div>
          </div>
          
          <div className="profile-image-container">
            <div className="profile-placeholder">
              <img src={ProfilePic} alt="Cade Wied" className="profile-image" />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Home;
